export const FETCH_POWER_METER_REQUEST = 'FETCH_POWER_METER_REQUEST';
export const FETCH_POWER_METER_SUCCESS = 'FETCH_POWER_METER_SUCCESS';
export const FETCH_POWER_METER_FAILURE = 'FETCH_POWER_METER_FAILURE';

export const fetchPowerMeterData = (rdate, did) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_POWER_METER_REQUEST });
    try {
      const response = await fetch(
        `https://esystems.cdl.lk/backend/CDPLCPowerMeterReading/PowerMeter/GetPowerMeterFilter?rdate=${rdate}&did=${did}`
      );
      const data = await response.json();
      
      if (data.statusCode === 200 && data.resultSet) {
        dispatch({
          type: FETCH_POWER_METER_SUCCESS,
          payload: data.resultSet,
        });
      } else {
        throw new Error('Invalid response structure');
      }
    } catch (error) {
      dispatch({
        type: FETCH_POWER_METER_FAILURE,
        payload: error.message,
      });
    }
  };
};